import { h } from 'preact';
import { RadiusButtonWrapper } from './RadiusButton.styled';

const RadiusButton = props => <RadiusButtonWrapper {...props} />;

export default RadiusButton;
